import React, { useEffect, useId, useMemo, useState } from "react";
import { useFetchUsers } from "../hooks/queries/useFetchUsers";
import { useDeleteUser } from "../hooks/mutations/useDeleteUser";
import {
  PlusIcon,
} from "@heroicons/react/24/outline";
import { useAuth } from "../hooks/auth/useAuth";
import { Spinner } from "../components/ui/Spinner";
import ConfirmDialog from "../components/ui/ConfirmDialog";
import { useCreateUser } from "../hooks/mutations/useCreateUser";
import { useUpdateUser } from "../hooks/mutations/useUpdateUser";
import { Pagination } from "../components/ui/Pagination";

function FigmaInfoIcon(props) {
  const maskId = useId();
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
      <mask id={maskId} style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M12.0008 16.5C12.1426 16.5 12.2612 16.4521 12.3567 16.3562C12.4522 16.2604 12.5 16.1417 12.5 16V11.5C12.5 11.3583 12.452 11.2396 12.356 11.1438C12.26 11.0479 12.1411 11 11.9993 11C11.8574 11 11.7388 11.0479 11.6433 11.1438C11.5478 11.2396 11.5 11.3583 11.5 11.5V16C11.5 16.1417 11.548 16.2604 11.644 16.3562C11.74 16.4521 11.8589 16.5 12.0008 16.5ZM12 9.577C12.1743 9.577 12.3205 9.518 12.4385 9.4C12.5565 9.282 12.6155 9.13583 12.6155 8.9615C12.6155 8.78717 12.5565 8.641 12.4385 8.523C12.3205 8.40517 12.1743 8.34625 12 8.34625C11.8257 8.34625 11.6795 8.40517 11.5615 8.523C11.4435 8.641 11.3845 8.78717 11.3845 8.9615C11.3845 9.13583 11.4435 9.282 11.5615 9.4C11.6795 9.518 11.8257 9.577 12 9.577ZM12.0033 21C10.7587 21 9.58867 20.7638 8.493 20.2915C7.3975 19.8192 6.4445 19.1782 5.634 18.3685C4.8235 17.5588 4.18192 16.6067 3.70925 15.512C3.23642 14.4175 3 13.2479 3 12.0033C3 10.7587 3.23617 9.58867 3.7085 8.493C4.18083 7.3975 4.82183 6.4445 5.6315 5.634C6.44117 4.8235 7.39333 4.18192 8.488 3.70925C9.5825 3.23642 10.7521 3 11.9967 3C13.2413 3 14.4113 3.23617 15.507 3.7085C16.6025 4.18083 17.5555 4.82183 18.366 5.6315C19.1765 6.44117 19.8181 7.39333 20.2908 8.488C20.7636 9.5825 21 10.7521 21 11.9967C21 13.2413 20.7638 14.4113 20.2915 15.507C19.8192 16.6025 19.1782 17.5555 18.3685 18.366C17.5588 19.1765 16.6067 19.8181 15.512 20.2908C14.4175 20.7636 13.2479 21 12.0033 21ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
          fill="#333333"
        />
      </g>
    </svg>
  );
}

function FigmaUsersTitleIcon(props) {
  const maskId = useId();
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
      <mask id={maskId} style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M2.59766 16.9693C2.59766 16.5051 2.71782 16.106 2.95816 15.772C3.19849 15.4382 3.52149 15.1714 3.92716 14.9715C4.79466 14.5585 5.65591 14.2293 6.51091 13.9838C7.36607 13.7383 8.39499 13.6155 9.59766 13.6155C10.8002 13.6155 11.829 13.7383 12.6842 13.9838C13.5393 14.2293 14.4006 14.5585 15.2679 14.9715C15.6736 15.1714 15.9966 15.4382 16.2369 15.772C16.4774 16.106 16.5977 16.5051 16.5977 16.9693V17.577C16.5977 17.832 16.4979 18.0689 16.2984 18.2875C16.0991 18.5062 15.8527 18.6155 15.5592 18.6155H3.63591C3.34241 18.6155 3.09599 18.5158 2.89666 18.3163C2.69732 18.1169 2.59766 17.8705 2.59766 17.577V16.9693ZM20.3669 18.6155H18.3744C18.4424 18.4565 18.4966 18.2889 18.5369 18.1125C18.5774 17.9362 18.5977 17.7577 18.5977 17.577V16.923C18.5977 16.3435 18.4803 15.7965 18.2457 15.282C18.0112 14.7675 17.6785 14.3261 17.2477 13.9578C17.7387 14.0578 18.2117 14.1965 18.6669 14.374C19.1219 14.5517 19.5719 14.7514 20.0169 14.973C20.4502 15.191 20.79 15.4699 21.0362 15.8098C21.2822 16.1498 21.4052 16.5209 21.4052 16.923V17.577C21.4052 17.8705 21.3055 18.1169 21.1062 18.3163C20.9068 18.5158 20.6604 18.6155 20.3669 18.6155ZM9.59766 11.3845C8.77266 11.3845 8.06641 11.0908 7.47891 10.5033C6.89141 9.91577 6.59766 9.20952 6.59766 8.38452C6.59766 7.55952 6.89141 6.85327 7.47891 6.26577C8.06641 5.67827 8.77266 5.38452 9.59766 5.38452C10.4227 5.38452 11.1289 5.67827 11.7164 6.26577C12.3039 6.85327 12.5977 7.55952 12.5977 8.38452C12.5977 9.20952 12.3039 9.91577 11.7164 10.5033C11.1289 11.0908 10.4227 11.3845 9.59766 11.3845ZM16.8669 8.38452C16.8669 9.20952 16.5732 9.91577 15.9857 10.5033C15.3982 11.0908 14.6919 11.3845 13.8669 11.3845C13.8246 11.3845 13.7707 11.3798 13.7052 11.3703C13.6398 11.3606 13.586 11.35 13.5437 11.3385C13.8825 10.9235 14.1428 10.4632 14.3247 9.95752C14.5067 9.45185 14.5977 8.92677 14.5977 8.38227C14.5977 7.83777 14.5024 7.31744 14.3119 6.82127C14.1216 6.3251 13.8655 5.8616 13.5437 5.43077C13.5975 5.4116 13.6513 5.3991 13.7052 5.39327C13.759 5.38744 13.8129 5.38452 13.8669 5.38452C14.6919 5.38452 15.3982 5.67827 15.9857 6.26577C16.5732 6.85327 16.8669 7.55952 16.8669 8.38452ZM3.59766 17.6155H15.5977V16.9693C15.5977 16.7346 15.539 16.5294 15.4217 16.3538C15.3043 16.1783 15.0937 16.0104 14.7899 15.85C14.0437 15.4514 13.2572 15.1459 12.4302 14.9338C11.6033 14.7216 10.6592 14.6155 9.59766 14.6155C8.53599 14.6155 7.59174 14.7216 6.76491 14.9338C5.93791 15.1459 5.15132 15.4514 4.40516 15.85C4.10132 16.0104 3.89074 16.1783 3.77341 16.3538C3.65624 16.5294 3.59766 16.7346 3.59766 16.9693V17.6155ZM9.59766 10.3845C10.1477 10.3845 10.6185 10.1887 11.0102 9.79702C11.4018 9.40535 11.5977 8.93452 11.5977 8.38452C11.5977 7.83452 11.4018 7.36369 11.0102 6.97202C10.6185 6.58035 10.1477 6.38452 9.59766 6.38452C9.04766 6.38452 8.57682 6.58035 8.18516 6.97202C7.79349 7.36369 7.59766 7.83452 7.59766 8.38452C7.59766 8.93452 7.79349 9.40535 8.18516 9.79702C8.57682 10.1887 9.04766 10.3845 9.59766 10.3845Z"
          fill="#333333"
        />
      </g>
    </svg>
  );
}

function FigmaDeleteIcon(props) {
  const maskId = useId();
  return (
    <svg width="39" height="40" viewBox="0 0 39 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
      <mask id={maskId} style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="7" y="8" width="25" height="24">
        <rect x="7.5" y="8" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M14.8077 28.5017C14.3106 28.5017 13.885 28.3247 13.531 27.9707C13.177 27.6167 13 27.1911 13 26.6939V14.0017H12.75C12.5375 14.0017 12.3594 13.9298 12.2158 13.7859C12.0719 13.6421 12 13.4639 12 13.2514C12 13.0388 12.0719 12.8607 12.2158 12.7172C12.3594 12.5735 12.5375 12.5017 12.75 12.5017H16.5C16.5 12.2569 16.5863 12.0482 16.7588 11.8757C16.9311 11.7034 17.1397 11.6172 17.3845 11.6172H21.6155C21.8603 11.6172 22.0689 11.7034 22.2413 11.8757C22.4138 12.0482 22.5 12.2569 22.5 12.5017H26.25C26.4625 12.5017 26.6406 12.5736 26.7843 12.7174C26.9281 12.8613 27 13.0394 27 13.2519C27 13.4646 26.9281 13.6427 26.7843 13.7862C26.6406 13.9299 26.4625 14.0017 26.25 14.0017H26V26.6939C26 27.1911 25.823 27.6167 25.469 27.9707C25.115 28.3247 24.6894 28.5017 24.1923 28.5017H14.8077ZM17.6543 25.0017C17.8668 25.0017 18.0448 24.9299 18.1885 24.7862C18.332 24.6424 18.4037 24.4642 18.4037 24.2517V16.7517C18.4037 16.5392 18.3318 16.361 18.188 16.2172C18.0443 16.0735 17.8662 16.0017 17.6535 16.0017C17.441 16.0017 17.2629 16.0735 17.1192 16.2172C16.9757 16.361 16.904 16.5392 16.904 16.7517V24.2517C16.904 24.4642 16.9758 24.6424 17.1195 24.7862C17.2633 24.9299 17.4416 25.0017 17.6543 25.0017ZM21.3465 25.0017C21.559 25.0017 21.7371 24.9299 21.8807 24.7862C22.0243 24.6424 22.096 24.4642 22.096 24.2517V16.7517C22.096 16.5392 22.0242 16.361 21.8805 16.2172C21.7367 16.0735 21.5584 16.0017 21.3458 16.0017C21.1333 16.0017 20.9552 16.0735 20.8115 16.2172C20.668 16.361 20.5962 16.5392 20.5962 16.7517V24.2517C20.5962 24.4642 20.6682 24.6424 20.812 24.7862C20.9557 24.9299 21.1338 25.0017 21.3465 25.0017Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

function FigmaEditIcon(props) {
  const maskId = useId();
  return (
    <svg width="39" height="40" viewBox="0 0 39 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
      <mask id={maskId} style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="8" y="7" width="24" height="25">
        <rect x="8" y="7.67578" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M12.404 28.1719C12.1478 28.1719 11.9332 28.0852 11.76 27.9119C11.5867 27.7387 11.5 27.524 11.5 27.2679V25.5354C11.5 25.2915 11.5468 25.0591 11.6405 24.8381C11.734 24.6171 11.8628 24.4245 12.027 24.2604L24.6905 11.6026C24.8417 11.4653 25.0086 11.3592 25.1913 11.2844C25.3741 11.2094 25.5658 11.1719 25.7663 11.1719C25.9668 11.1719 26.1609 11.2075 26.3488 11.2786C26.5367 11.3498 26.7032 11.463 26.848 11.6181L28.0693 12.8546C28.2244 12.9995 28.335 13.1661 28.401 13.3546C28.467 13.5431 28.5 13.7316 28.5 13.9201C28.5 14.1213 28.4657 14.3132 28.397 14.4959C28.3283 14.6787 28.2191 14.8457 28.0693 14.9969L15.4115 27.6449C15.2473 27.809 15.0548 27.9379 14.8338 28.0314C14.6128 28.125 14.3803 28.1719 14.1365 28.1719H12.404ZM25.552 15.3661L27 13.9276L25.7443 12.6719L24.3057 14.1199L25.552 15.3661Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

function EmptyUsersIcon() {
  return (
    <svg width="82" height="82" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg" className="opacity-80">
      <g opacity="0.8">
        <path fillRule="evenodd" clipRule="evenodd" d="M54.1351 40.6117L40.5449 54.2006C40.5449 54.2006 45.3778 52.6913 52.3235 55.1065C53.492 55.5126 55.4471 53.5574 55.041 52.3889C52.6258 45.4433 54.1351 40.6117 54.1351 40.6117Z" fill="#8DA5CF"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M17.7636 17.8298C26.0149 9.57984 39.4104 9.57984 47.6616 17.8298C55.9116 26.0811 55.9116 39.4765 47.6616 47.7278C39.4104 55.9777 26.0149 55.9777 17.7636 47.7278C9.51368 39.4765 9.51368 26.0811 17.7636 17.8298Z" fill="#E9F3FC"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M44.9279 15.521C45.8863 16.2013 46.8011 16.9714 47.6608 17.8298C55.9108 26.0811 55.9108 39.4765 47.6608 47.7278C39.4096 55.9777 26.0141 55.9777 17.7628 47.7278C17.2773 47.2409 16.8198 46.7374 16.3906 46.2185C24.3882 48.8168 33.5286 46.9411 39.8785 40.5912C46.6512 33.8185 48.3348 23.8709 44.9279 15.521Z" fill="#CADCF0"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M15.9516 16.0182C25.2023 6.76754 40.2224 6.76754 49.473 16.0182C58.7236 25.2688 58.7236 40.2889 49.473 49.5395C40.2224 58.7901 25.2023 58.7901 15.9516 49.5395C6.70102 40.2889 6.70102 25.2688 15.9516 16.0182ZM18.6692 18.7357C26.4195 10.9854 39.0052 10.9854 46.7555 18.7357C54.5057 26.486 54.5057 39.0717 46.7555 46.822C39.0052 54.5723 26.4195 54.5723 18.6692 46.822C10.9189 39.0717 10.9189 26.486 18.6692 18.7357Z" fill="#A4BBDB"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M11.4763 43.319C7.07904 34.454 8.57042 23.3994 15.9517 16.0181C22.8833 9.08655 33.0538 7.34918 41.6113 10.806C41.6728 11.5914 41.7048 12.3871 41.7048 13.1904C41.7048 13.8105 41.6856 14.4268 41.6485 15.0392C34.2031 11.2903 24.8833 12.5229 18.6692 18.7356C12.0823 25.3225 11.0932 35.4021 15.7044 43.0384C14.354 43.2229 12.9754 43.319 11.5762 43.319H11.4763Z" fill="#B9CAE3"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M51.2841 59.5051C49.0329 57.2539 49.0329 53.6036 51.2841 51.3512C53.5352 49.1001 57.1868 49.1001 59.4379 51.3512L78.0109 69.9242C78.5106 70.4239 77.0897 72.6571 74.8398 74.907C72.59 77.1569 70.3568 78.5778 69.8571 78.0781L51.2841 59.5051Z" fill="#A4BBDB"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M51.2841 59.5051C49.0329 57.2539 49.0329 53.6036 51.2841 51.3512C53.5352 49.1001 57.1868 49.1001 59.4379 51.3512L76.2479 68.1612C76.7476 68.6609 75.3267 70.8941 73.0768 73.144C70.827 75.3939 68.5938 76.8148 68.0941 76.3151L51.2841 59.5051Z" fill="#CADCF0"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M29.9982 28.7448C29.9687 27.5238 30.4274 26.632 31.1347 26.1093C32.2468 25.2893 33.9086 25.3239 34.8106 26.3399C35.1975 26.7768 35.4217 27.3944 35.4281 28.1759C35.4435 30.0504 34.5646 31.1459 33.7036 32.2798C32.5453 33.8083 31.3883 35.3791 31.2448 38.0018C31.2064 38.7091 31.7497 39.3125 32.4556 39.351C33.1616 39.3894 33.7664 38.8474 33.8048 38.1415C33.9124 36.1491 34.8657 34.9883 35.7459 33.8275C36.9246 32.2734 38.0124 30.723 37.9906 28.1554C37.9778 26.6461 37.4743 25.4814 36.726 24.6384C34.9784 22.6704 31.7689 22.4577 29.6138 24.0464C28.3223 24.9997 27.3832 26.5782 27.4357 28.805C27.4523 29.5123 28.0404 30.0722 28.7477 30.0555C29.4537 30.0389 30.0148 29.452 29.9982 28.7448Z" fill="#8DA5CF"/>
        <path d="M32.406 44.1095C33.2764 44.1095 33.982 43.4039 33.982 42.5336C33.982 41.6632 33.2764 40.9576 32.406 40.9576C31.5356 40.9576 30.8301 41.6632 30.8301 42.5336C30.8301 43.4039 31.5356 44.1095 32.406 44.1095Z" fill="#8DA5CF"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M55.4638 10.8867L59.3076 4.48048C59.6715 3.87445 59.4754 3.08648 58.8681 2.72261C58.2621 2.36001 57.4741 2.55604 57.1103 3.16207L53.2665 9.56833C52.9026 10.1756 53.0999 10.9636 53.706 11.3262C54.3133 11.6901 55.1 11.494 55.4638 10.8867Z" fill="#8DA5CF"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M61.5248 15.1084L75.6185 4.85845C76.1899 4.44204 76.3168 3.63998 75.9017 3.06854C75.4853 2.49582 74.6832 2.37026 74.1118 2.78539L60.018 13.0354C59.4453 13.4518 59.3197 14.2539 59.7349 14.8253C60.1513 15.398 60.9533 15.5236 61.5248 15.1084Z" fill="#8DA5CF"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M63.6442 23.0022L73.8942 20.4397C74.5809 20.268 74.9986 19.5723 74.8269 18.8856C74.6552 18.2001 73.9595 17.7824 73.2728 17.9541L63.0228 20.5166C62.3373 20.6883 61.9196 21.384 62.0913 22.0708C62.263 22.7562 62.9587 23.1739 63.6442 23.0022Z" fill="#8DA5CF"/>
      </g>
    </svg>
  );
}

export default function UsersListPage() {
  const { data: users = [], isLoading, isError, error } = useFetchUsers();
  const { user: me } = useAuth();
  const del = useDeleteUser();
  const create = useCreateUser();
  const update = useUpdateUser();

  // Pagination state (match RouteList)
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const totalCount = users.length;
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));

  // keep page in range when data/pageSize changes
  useEffect(() => {
    setPage((p) => Math.min(Math.max(1, p), totalPages));
  }, [totalPages]);

  const startItem = totalCount === 0 ? 0 : (page - 1) * pageSize + 1;
  const endItem = Math.min(page * pageSize, totalCount);

  const paginatedUsers = useMemo(() => {
    const startIndex = (page - 1) * pageSize;
    const endIndex2 = Math.min(startIndex + pageSize, totalCount);
    return users.slice(startIndex, endIndex2);
  }, [users, page, pageSize, totalCount]);

  // Delete confirmation state
  const [deleteConfirm, setDeleteConfirm] = useState({ isOpen: false, userId: null, username: "" });

  // Create user modal state
  const [createOpen, setCreateOpen] = useState(false);
  const [newUsername, setNewUsername] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newRole, setNewRole] = useState("User");

  // Edit user modal state
  const [editOpen, setEditOpen] = useState(false);
  const [editUserId, setEditUserId] = useState(null);
  const [editUsername, setEditUsername] = useState("");
  const [editPassword, setEditPassword] = useState("");
  const [editRole, setEditRole] = useState("User");

  const [activeAction, setActiveAction] = useState(null);
  const isActionActive = (userId, action) =>
    activeAction?.userId === userId && activeAction?.action === action;

  const handleDelete = (id, username) => {
    setActiveAction({ userId: id, action: "delete" });
    setDeleteConfirm({ isOpen: true, userId: id, username });
  };

  const confirmDelete = () => {
    const { userId } = deleteConfirm;
    del.mutate(userId);
    setDeleteConfirm({ isOpen: false, userId: null, username: "" });
    setActiveAction(null);
  };

  const closeCreateModal = () => {
    setCreateOpen(false);
    setNewUsername("");
    setNewPassword("");
    setNewRole("User");
  };

  const closeEditModal = () => {
    setEditOpen(false);
    setEditUserId(null);
    setEditUsername("");
    setEditPassword("");
    setEditRole("User");
    setActiveAction(null);
  };

  const submitCreate = (e) => {
    e.preventDefault();
    const username = newUsername.trim();
    const password = newPassword;
    if (!username || !password) return;

    create.mutate(
      { username, password, groups: [newRole] },
      { onSuccess: closeCreateModal }
    );
  };

  const getRoleLabel = (u) => {
    if (u?.is_staff) return "Admin";
    const groups = Array.isArray(u?.groups) ? u.groups : [];
    if (groups.some((g) => String(g).toLowerCase() === "admin")) return "Admin";
    return "User";
  };

  const openEditForUser = (u) => {
    setActiveAction({ userId: u?.id ?? null, action: "edit" });
    setEditUserId(u?.id ?? null);
    setEditUsername(u?.username ?? "");
    setEditPassword("");
    setEditRole(getRoleLabel(u));
    setEditOpen(true);
  };

  const submitEdit = (e) => {
    e.preventDefault();
    const id = editUserId;
    const username = editUsername.trim();
    const password = editPassword;
    if (!id || !username) return;

    update.mutate(
      { id, username, ...(password ? { password } : {}), groups: [editRole] },
      { onSuccess: closeEditModal }
    );
  };

  const formatDateParts = (iso) => {
    if (!iso) return { date: "-", time: "-" };
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return { date: "-", time: "-" };
    return {
      date: d.toLocaleDateString("en-GB"),
      time: d.toLocaleTimeString("el-GR", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      }),
    };
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <Spinner className="h-12 w-12 text-camber-blue-500 mx-auto mb-4" />
          <p className="text-camber-gray-600">Loading users...</p>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="p-6">
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <p className="text-red-700 font-medium">Error loading users: {error?.message}</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="min-h-screen w-full bg-[#F4F7FB] pt-[32px] px-[32px] pb-[40px]"
      style={{ fontFamily: "'Open Sans', sans-serif" }}
    >
      <div className="w-full flex flex-col items-stretch gap-[16px]">
        {/* Header */}
        <div className="w-full h-[89px] bg-[#FDFEFF] rounded-[8px]">
          <div className="h-full px-[24px] py-[16px] flex items-center justify-between">
            <div className="flex flex-col items-start justify-between h-full">
              <div className="flex items-center gap-[8px]">
                <h1 className="text-[20px] font-extrabold leading-[31px] text-[#333333]">Users</h1>
                <FigmaUsersTitleIcon className="w-[24px] h-[24px]" />
              </div>
              <div className="text-[14px] font-light leading-[22px] text-[#333333]">
                Manage team members and permissions
              </div>
            </div>

            <button
              type="button"
              onClick={() => setCreateOpen(true)}
              className="h-[40px] w-[134px] rounded-[4px] bg-[#5937D6] py-[8px] pl-[16px] pr-[12px] flex items-center justify-center gap-[4px]"
            >
              <PlusIcon className="w-[24px] h-[24px] text-[#FAFAFA]" aria-hidden="true" />
              <span className="text-[14px] font-normal leading-[22px] text-[#FAFAFA]">Create User</span>
            </button>
          </div>
        </div>

        {/* Tip */}
        <div className="w-full h-[40px] bg-[#F3F5FE] border border-[#C9D8FC] rounded-[4px] px-[15px] py-[8px] flex items-center gap-[8px]">
          <FigmaInfoIcon className="w-[24px] h-[24px]" />
          <div className="text-[12px] font-bold leading-[19px] text-[#333333]">
            Tip: Only admin users can manage team members. Users cannot delete themselves.
          </div>
        </div>

        {/* List card (match RouteList structure) */}
        <div className={`w-full bg-[#FDFEFF] rounded-[8px] p-[8px] ${totalCount === 0 ? "min-h-[529px]" : ""}`}>
          {/* Top controls bar (RouteList-like) */}
          <div className="w-full min-h-[64px] bg-[#F4F7FA] rounded-[4px] px-[16px] py-[16px] flex items-center justify-between">
            <div /> {/* no filters */}
            {totalCount > 0 && (
              <Pagination
                variant="compact"
                currentPage={page}
                totalPages={totalPages}
                totalCount={totalCount}
                pageSize={pageSize}
                onPageChange={(next) => setPage(next)}
                onPageSizeChange={(nextSize) => {
                  setPageSize(nextSize);
                  setPage(1);
                }}
              />
            )}
          </div>

          {/* Table */}
          <div className="mt-[12px] w-full bg-[#FDFEFF] rounded-[8px] overflow-hidden">
            <div className="h-[34px] border-b border-[#E0E2E5] rounded-t-[8px] flex items-center shrink-0">
              <div className="px-[24px] w-full flex items-center justify-between">
                <div className="grid grid-cols-[140px_220px_110px_110px_80px_70px] gap-[28px] items-center w-[908px]">
                  <div className="text-[12px] font-normal leading-[19px] text-[#828282] w-[120px]">Username</div>
                  <div className="text-[12px] font-normal leading-[19px] text-[#828282]">Email</div>
                  <div className="text-[12px] font-normal leading-[19px] text-[#828282]">Date</div>
                  <div className="text-[12px] font-normal leading-[19px] text-[#828282] w-[120px]">Time</div>
                  <div className="text-[12px] font-normal leading-[19px] text-[#828282]">Role</div>
                  <div className="text-[12px] font-normal leading-[19px] text-[#828282] w-[70px]">Active</div>
                </div>
                <div className="w-[90px]" />
              </div>
            </div>

            {paginatedUsers.length === 0 ? (
              <div className="h-[420px] flex flex-col items-center justify-center">
                <EmptyUsersIcon />
                <div className="mt-[18px] text-[12px] leading-[155%] text-[#969696]">No users found.</div>
              </div>
            ) : (
              <div className="max-h-[calc(100vh-326px)] overflow-auto">
                {paginatedUsers.map((u) => {
                  const isMe = me?.id && u?.id && me.id === u.id;
                  const dt = formatDateParts(u?.date_joined || u?.created_at);
                  const role = getRoleLabel(u);

                  const actionBtnBase =
                    "flex h-[40px] w-[39px] items-center justify-center rounded-[8px] transition-colors duration-200";
                  const actionBtnIdle = "bg-transparent text-[#BBBABB]";
                  const actionBtnHover = "hover:bg-[#D4DAFE] hover:text-[#483ED1]";
                  const actionBtnActive = "bg-[#D4DAFE] text-[#483ED1]";

                  return (
                    <div
                      key={u.id}
                      className="group cursor-pointer h-[52px] bg-[#FDFEFF] border-b border-[#E0E2E5] flex items-center transition-colors hover:bg-[#F3F5FE] hover:border-[#C9D8FC]"
                    >
                      <div className="pl-[24px] pr-[12px] w-full flex items-center justify-between">
                        <div className="grid grid-cols-[140px_220px_110px_110px_80px_70px] gap-[28px] items-center w-[908px]">
                          <div className="text-[14px] font-normal leading-[22px] text-[#000000] truncate">
                            {u.username}
                          </div>
                          <div className="text-[14px] font-normal leading-[22px] text-[#000000] truncate">
                            {u.email || "-"}
                          </div>
                          <div className="text-[14px] font-normal leading-[22px] text-[#000000]">
                            {dt.date}
                          </div>
                          <div className="text-[14px] font-normal leading-[22px] text-[#000000] w-[120px]">
                            {dt.time}
                          </div>
                          <div className="text-[14px] font-normal leading-[22px] text-[#000000]">{role}</div>
                          <div className="w-[70px]">
                            <span
                              className={[
                                "inline-flex items-center justify-center h-[22px] px-[10px] rounded-[99px] text-[12px] leading-[19px]",
                                u?.is_active ? "bg-[#E8F5E9] text-[#1B5E20]" : "bg-[#FCE8E6] text-[#B3261E]",
                              ].join(" ")}
                            >
                              {u?.is_active ? "Active" : "Inactive"}
                            </span>
                          </div>
                        </div>

                        <div className="w-[90px] h-[40px] flex items-center justify-end gap-[12px]">
                          {/* DELETE */}
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              setActiveAction({ userId: u.id, action: "delete" });
                              handleDelete(u.id, u.username);
                            }}
                            className={[
                              actionBtnBase,
                              actionBtnIdle,
                              actionBtnHover,
                              isActionActive(u.id, "delete") ? actionBtnActive : "",
                            ].join(" ")}
                            title={isMe ? "You cannot delete yourself" : "Delete user"}
                            disabled={del.isPending || isMe}
                          >
                            <FigmaDeleteIcon className="w-[39px] h-[40px]" />
                          </button>

                          {/* EDIT */}
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              setActiveAction({ userId: u.id, action: "edit" });
                              openEditForUser(u);
                            }}
                            className={[
                              actionBtnBase,
                              actionBtnIdle,
                              actionBtnHover,
                              isActionActive(u.id, "edit") ? actionBtnActive : "",
                            ].join(" ")}
                            title="Edit user"
                            disabled={update.isPending}
                          >
                            <FigmaEditIcon className="w-[39px] h-[40px]" />
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          {del.isError && (
            <div className="w-full mt-[16px] bg-[#FDFEFF] border border-red-200 rounded-[8px] p-[12px]">
              <p className="text-red-700 text-[12px] font-medium leading-[19px]">
                Delete failed: {del.error?.response?.data?.detail || del.error?.message}
              </p>
            </div>
          )}
        </div>
        {/* Footer text */}
        <div className="px-[8px]">
          <div className="text-[12px] leading-[155%] text-[#969696]">
            {totalCount === 0 ? "Showing 0 results" : `Showing ${startItem}-${endItem} results`}
          </div>
        </div>
      </div>

      <ConfirmDialog
        isOpen={deleteConfirm.isOpen}
        onClose={() => {
          setDeleteConfirm({ isOpen: false, userId: null, username: "" });
          setActiveAction(null);
        }}
        onConfirm={confirmDelete}
        title="Delete User"
        message={`Delete user "${deleteConfirm.username}"? This cannot be undone.`}
        confirmText="Delete"
        cancelText="Cancel"
        variant="danger"
        isLoading={del.isPending}
      />

      {/* Create User Modal */}
      {createOpen && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center"
          role="dialog"
          aria-modal="true"
          aria-label="Create User"
        >
          <button
            type="button"
            className="absolute inset-0 w-full h-full"
            style={{ background: "rgba(19, 19, 19, 0.69)" }}
            onClick={closeCreateModal}
            aria-label="Close create user modal"
          />

          <form
            onSubmit={submitCreate}
            className="relative w-[435px] h-[418px] bg-white rounded-[8px] px-[24px] pt-[24px] pb-[32px] flex flex-col items-start gap-[24px]"
            style={{ fontFamily: "'Open Sans', sans-serif" }}
          >
            <div className="text-[18px] font-semibold leading-[28px] text-[#242424]">Create User</div>

            <div className="w-[387px] flex flex-col items-start gap-[24px]">
              {/* Username */}
              <div className="w-full flex flex-col items-start gap-[4px]">
                <div className="text-[14px] font-normal leading-[22px] text-[#212529]">Usersname</div>
                <input
                  type="text"
                  value={newUsername}
                  onChange={(e) => setNewUsername(e.target.value)}
                  placeholder="Text"
                  className="w-full h-[40px] bg-white border border-[#E0E2E5] rounded-[8px] px-[12px]"
                  style={{ color: "#212529" }}
                />
              </div>

              {/* Password */}
              <div className="w-full flex flex-col items-start gap-[4px]">
                <div className="text-[14px] font-normal leading-[22px] text-[#212529]">Password</div>
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Text"
                  className="w-full h-[40px] bg-white border border-[#E0E2E5] rounded-[8px] px-[12px]"
                />
              </div>

              {/* Role */}
              <div className="w-full flex flex-col items-start gap-[4px]">
                <div className="text-[14px] font-normal leading-[22px] text-[#212529]">Role</div>
                <div className="relative w-full">
                  <select
                    value={newRole}
                    onChange={(e) => setNewRole(e.target.value)}
                    className="w-full h-[40px] bg-white border border-[#E0E2E5] rounded-[4px] px-[8px] pr-[40px] appearance-none"
                    style={{ color: newRole ? "#212529" : "#939393" }}
                  >
                    <option value="User">User</option>
                    <option value="Admin">Admin</option>
                  </select>

                  <span className="pointer-events-none absolute right-[8px] top-1/2 -translate-y-1/2 w-[24px] h-[24px] flex items-center justify-center">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <path d="M7 10L12 15L17 10" stroke="#939393" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                </div>
              </div>
            </div>

            {create.isError && (
              <div className="w-[387px] text-[12px] font-normal leading-[19px] text-red-700">
                {create.error?.response?.data?.detail || create.error?.message || "Failed to create user"}
              </div>
            )}

            <div className="w-[387px] h-[40px] flex items-center justify-between gap-[131px]">
              <button
                type="button"
                onClick={closeCreateModal}
                className="w-[179px] h-[40px] rounded-[4px] bg-[#E2DCF8] flex items-center justify-center px-[24px] py-[8px]"
              >
                <span className="text-[16px] font-normal leading-[25px] text-[#2C1B6B]">Cancel</span>
              </button>

              <button
                type="submit"
                disabled={create.isPending || !newUsername.trim() || !newPassword}
                className="w-[180px] h-[40px] rounded-[4px] bg-[#5937D6] flex items-center justify-center px-[24px] disabled:opacity-60"
              >
                <span className="text-[16px] font-normal leading-[25px] text-[#E3DDF8]">
                  {create.isPending ? "Creating..." : "Create"}
                </span>
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Edit User Modal */}
      {editOpen && (
        <div
          className="fixed inset-0 z-[110] flex items-center justify-center"
          role="dialog"
          aria-modal="true"
          aria-label="Edit User"
        >
          <button
            type="button"
            className="absolute inset-0 w-full h-full"
            style={{ background: "rgba(19, 19, 19, 0.69)" }}
            onClick={closeEditModal}
            aria-label="Close edit user modal"
          />

          <form
            onSubmit={submitEdit}
            className="relative w-[435px] h-[418px] bg-white rounded-[8px] px-[24px] pt-[24px] pb-[32px] flex flex-col items-start gap-[24px]"
            style={{ fontFamily: "'Open Sans', sans-serif" }}
          >
            <div className="text-[18px] font-semibold leading-[28px] text-[#242424]">Edit User</div>

            <div className="w-[387px] flex flex-col items-start gap-[24px]">
              {/* Username */}
              <div className="w-full flex flex-col items-start gap-[4px]">
                <div className="text-[14px] font-normal leading-[22px] text-[#212529]">Usersname</div>
                <input
                  type="text"
                  value={editUsername}
                  onChange={(e) => setEditUsername(e.target.value)}
                  placeholder="Text"
                  className="w-full h-[40px] bg-white border border-[#E0E2E5] rounded-[8px] px-[12px]"
                  style={{ color: "#212529" }}
                />
              </div>

              {/* Password */}
              <div className="w-full flex flex-col items-start gap-[4px]">
                <div className="text-[14px] font-normal leading-[22px] text-[#212529]">Password</div>
                <input
                  type="password"
                  value={editPassword}
                  onChange={(e) => setEditPassword(e.target.value)}
                  placeholder="************"
                  className="w-full h-[40px] bg-white border border-[#E0E2E5] rounded-[8px] px-[12px]"
                />
              </div>

              {/* Role */}
              <div className="w-full flex flex-col items-start gap-[4px]">
                <div className="text-[14px] font-normal leading-[22px] text-[#212529]">Role</div>
                <div className="relative w-full">
                  <select
                    value={editRole}
                    onChange={(e) => setEditRole(e.target.value)}
                    className="w-full h-[40px] bg-white border border-[#E0E2E5] rounded-[4px] px-[8px] pr-[40px] appearance-none"
                    style={{ color: editRole ? "#212529" : "#939393" }}
                  >
                    <option value="User">User</option>
                    <option value="Admin">Admin</option>
                  </select>

                  <span className="pointer-events-none absolute right-[8px] top-1/2 -translate-y-1/2 w-[24px] h-[24px] flex items-center justify-center">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <path d="M7 10L12 15L17 10" stroke="#939393" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                </div>
              </div>
            </div>

            {update.isError && (
              <div className="w-[387px] text-[12px] font-normal leading-[19px] text-red-700">
                {update.error?.response?.data?.detail || update.error?.message || "Failed to update user"}
              </div>
            )}

            <div className="w-[387px] flex gap-[24px]">
              <button type="button" onClick={closeEditModal}
                className="flex-1 h-[40px] rounded-[8px] bg-[#E2DCF8] flex items-center justify-center">
                <span className="text-[16px] leading-[28px] text-[#2C1B6B] whitespace-nowrap">Cancel</span>
              </button>

              <button type="submit" disabled={update.isPending || !editUserId || !editUsername.trim()}
                className="flex-1 h-[40px] rounded-[8px] bg-[#5937D6] flex items-center justify-center disabled:opacity-60">
                <span className="text-[16px] leading-[28px] text-[#E3DDF8] whitespace-nowrap">
                  {update.isPending ? "Saving..." : "Save Changes"}
                </span>
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
